export default __webpack_public_path__ + "static/media/add.338a897d.svg";